import React, { useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  console.error("REACT_APP_API_URL is not defined in .env");
}
export default function SubmitRequest({ onSubmit }) {

const projectGroupsMap = {
  "U2Innovate Project-1: AI Chatbot Development": [
    "Group 3",
    "Group 5"
  ],

  "U2Innovate Project-2: Cyber Security Dashboard": [
    "Group 6",
    "Group 7",
    "Group 9"
  ],

  "U2Innovate Project-3: AI-Based Student Performance Prediction": [
    "Group 11",
    "Group 12"
  ],

  "U2Innovate Project-4: Explainable AI for Healthcare Diagnosis": [
    "Group 16",
    "Group 17"
  ],

  "U2Innovate Project-5: AI Powered Fake News Detection": [
    "Group 21",
    "Group 22",
    "Group 23",
    "Group 24",
    "Group 25"
  ],

  "U2Innovate Project-6: AI Based Phishing Detection Framework": [
    "Group 26",
    "Group 27",
    "Group 28",
    "Group 29",
    "Group 30"
  ],

  "U2Innovate Project-9: Blockchain-Based Academic Certificate Verification": [
    "Group 41",
    "Group 44"
  ],

  "U2Innovate Project-10: Blockchain for Supply Chain Transparency": [
    "Group 46"
  ],

  "U2Innovate Project-12: Air Quality Monitoring and Prediction System": [
    "Group 56",
    "Group 60"
  ],

  "U2Innovate Project-16: Social Media Sentiment Analysis": [
    "Group 76",
    "Group 77",
    "Group 78",
    "Group 79",
    "Group 80"
  ],

  "U2Innovate Project-17: Vision-Based Object Detection for Autonomous Systems": [
    "Group 81",
    "Group 82"
  ],

  "U2Innovate Project-18: AI-Driven Predictive Maintenance System": [
    "Group 86"
  ],

  "U2Innovate Project-19: Multi-Agent AI System for Academic Assistant": [
    "Group 91",
    "Group 92",
    "Group 93",
    "Group 94",
    "Group 95"
  ],

  "U2Innovate Project-20: Retrieval-Augmented Generation (RAG)": [
    "Group 96",
    "Group 97",
    "Group 98",
    "Group 99",
    "Group 100"
  ],

  "U2Innovate Project-21: AI Agent for Cybersecurity Incident Response": [
    "Group 101",
    "Group 102",
    "Group 103",
    "Group 104",
    "Group 105"
  ],

  "U2Innovate Project-22: Hallucination Detection in Large Language Models": [
    "Group 106",
    "Group 107",
    "Group 108"
  ]
};
  const [form, setForm] = useState({
    studentName: "",
    email: "",
    projectTitle: "",
    GroupNumber: "",
    question: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleProjectChange = (e) => {
    const selectedProject = e.target.value;

    setForm({
      ...form,
      projectTitle: selectedProject,
      GroupNumber: "" // reset group when project changes
    });
  };

const handleSubmit = async () => {
  try {
    const formData = new FormData();

    formData.append("studentName", form.studentName);
    formData.append("email", form.email);
    formData.append("projectTitle", form.projectTitle);
    formData.append("GroupNumber", form.GroupNumber);
    formData.append("question", form.question);

    const response = await fetch(`${API_URL}/questions`, {
      method: "POST",
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    setForm({
      studentName: "",
      email: "",
      projectTitle: "",
      GroupNumber: "",
      question: ""
    });

    if (onSubmit) onSubmit();

  } catch (error) {
    console.error("Submission error:", error);
    alert("Failed to submit question. Please try again.");
  }
};
  return (
    <div>
      <h2>Ask Your Question</h2>
<h4>Submit your request to the U2U Platform Support Team</h4>
      {/* PROJECT DROPDOWN */}
      <select
        name="projectTitle"
        value={form.projectTitle}
        onChange={handleProjectChange}
      >
        <option value="">Select Project</option>
        {Object.keys(projectGroupsMap).map((project) => (
          <option key={project} value={project}>
            {project}
          </option>
        ))}
      </select>

      <br />
<br></br>
      {/* GROUP NUMBER DROPDOWN (DEPENDENT) */}
      <select
        name="GroupNumber"
        value={form.GroupNumber}
        onChange={handleChange}
        disabled={!form.projectTitle}
      >
        <option value="">Select Group Number</option>

        {form.projectTitle &&
          projectGroupsMap[form.projectTitle].map((group) => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
      </select>

      <br />
<input
        name="studentName"
        placeholder="Student Name"
        onChange={handleChange}
        value={form.studentName}
      />
      <input
        name="email"
        placeholder="Email"
        onChange={handleChange}
        value={form.email}
      />
      <br />
      <br />
      <br></br>
<textarea
  name="question"
  placeholder="My request to the U2U Platform Support Team is"
  onChange={handleChange}
  value={form.question}
  rows={4}
  style={{
    width: "100%",
maxWidth: "900px",
    boxSizing: "border-box"
  }}
/>
      <br></br>
     <div style={{ marginTop: "10px" }}>
  
</div> 
      <br />

      <button onClick={handleSubmit}
      style={{
    width: "200px",
    backgroundColor: "green",
    color: "white",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  }}
      >Submit</button>
    </div>
  );
}